import React, { useState } from "react";

export default function RevealSecretView({ password, unlinkSecret, decryptSecret, onBack }) {
  const [input, setInput] = useState("");
  const [error, setError] = useState("");
  const [secret, setSecret] = useState(null);

  const handleSubmit = async () => {
    if (input !== password) {
      setError("Incorrect password.");
      return;
    }

    try {
      const decrypted = await decryptSecret(unlinkSecret, input);
      setSecret(decrypted);
    } catch (err) {
      setError("Failed to decrypt secret.");
    }
  };

  return (
    <div style={{ backgroundColor: "#000", color: "#fff", height: "100vh", padding: "2rem" }}>
      
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "2rem" }}>
        <button
          onClick={onBack}
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            marginRight: "1rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Reveal Unlink Secret</h2>
      </div>

      {!secret ? (
        <>
          <p>Enter your password to unlock your Unlink secret.</p>
          <input
            type="password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Password"
            style={{
              width: "100%",
              padding: "0.5rem",
              borderRadius: "4px",
              border: "1px solid #444",
              backgroundColor: "#111",
              color: "#fff",
              marginBottom: "1rem",
            }}
          />
          {error && <div style={{ color: "#f66", marginBottom: "1rem" }}>{error}</div>}
          <button
            onClick={handleSubmit}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "#111",
              color: "#fff",
              border: "1px solid #444",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Reveal Secret
          </button>
        </>
      ) : (
        <>
          <div style={{ wordBreak: "break-all", marginTop: "1rem", fontSize: "0.9rem", color: "#0f0" }}>
            {secret}
          </div>
          <p style={{ fontSize: "0.75rem", color: "#f66", marginTop: "1rem" }}>
            Never share this secret. Anyone with access to it can read your messages.
          </p>
        </>
      )}
    </div>
  );
}